import { Component } from '@angular/core';

@Component({
  selector: 'app-posts-navigation',
  templateUrl: './posts-navigation.component.html',
})
export class PostsNavigationComponent {}
